import request from "@/lib/api/handler";
import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { QueryKeys } from "@/queries/utils";

import { ConversationSummary } from "@/queries/chat/user-conversation";

export const useMarkConversationRead = (conversationId: string) => {
  const qc = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async (lastSeenMessageId?: string) => {
      const token = await getAccessTokenSilently();
      return request<{ lastSeenMessageId?: string; lastSeenAt: string }>({
        method: "POST",
        path: `/api/chat/${conversationId}/mark-read`,
        token,
        body: JSON.stringify({
          messageId: lastSeenMessageId ?? null,
        }),
      });
    },
    onSuccess: (data) => {
      // Optimistically update the lastSeenAt field
      qc.setQueryData<ConversationSummary[]>(
        QueryKeys.chatConversations,
        (oldData) => {
          if (!oldData) {
            return oldData;
          }

          return oldData.map((conversation) =>
            conversation.id === conversationId
              ? { ...conversation, ...data }
              : conversation,
          );
        },
      );
    },
  });

  return {
    markConversationRead: mutate,
    isMarkingConversationRead: isPending,
    markConversationReadError: error,
  };
};
